export async function getBlockCount(client) {
    const data = await client.request({
        method: 'getblockcount',
        params: [],
    }, { dedupe: true });
    return data;
}
//# sourceMappingURL=getBlockCount.js.map